<template>
  <div>
    <Head title="Especialidades" />
    <div class="shadow_box rounded-lg p-6">
      <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">Especialidades</h1>
      <data-table
        v-if="loadTable"
        v-model:columns="columns"
        route="specialties/list"
        no-data-label="Nenhuma especialidade cadastrada"
        no-result-label="Nenhuma especialidade encontrada"
      >
        <template #table.cell.content.actions="{ value, row }">
            <div class="inline-grid grid-cols-2 gap-4 ">
                <span @click="openModalEdit(row)"><font-awesome-icon icon="fa-pen-to-square" class="text-primary text-lg cursor-pointer" /></span>
                <span @click="openModalConfirmDelete(row)"><font-awesome-icon icon="fa-trash-can" class="text-red-600 text-lg cursor-pointer" /></span>
            </div>
        </template>
        <template #grid.content.body.actions="{ value, row }">
            <div class="inline-grid grid-cols-2 gap-4 ">
                <span @click="openModalEdit(row)"><font-awesome-icon icon="fa-pen-to-square" class="text-primary text-lg cursor-pointer" /></span>
                <span @click="openModalConfirmDelete(row)"><font-awesome-icon icon="fa-trash-can" class="text-red-600 text-lg cursor-pointer" /></span>
            </div>
        </template>
    
        <template #after.reload-button>
          <div class="flex flex-col lg:flex-row w-full">
            <button class="flex justify-center items-end font-roboto font-medium btn-primary uppercase w-full" @click.prevent="openModalConfig">
              <font-awesome-icon icon="fa-cog" class="text-white text-lg mr-2" /><span class=""> Reordenar Especialidades</span>
            </button>

            <button class="flex justify-center items-end font-roboto font-medium btn-primary uppercase w-full mt-4 ml-0 lg:ml-2 lg:mt-0" @click.prevent="openSetPriceAll">
              <font-awesome-icon icon="fa-dollar" class="text-white text-lg mr-2" />
              <span class="">Valor padrão</span>
            </button>

            <button class="flex justify-center items-end font-roboto font-medium btn-primary uppercase w-full mt-4 ml-0 lg:ml-2 lg:mt-0" @click.prevent="openModalEdit({})">
              <font-awesome-icon icon="fa-plus" class="text-white text-lg mr-2" /><span class=""> Adicionar Especialidade</span>
            </button>
          </div>
        </template>
      </data-table>
    </div>
    <modal-delete ref="modalDelete" @confirm="reloadTable"></modal-delete>

    <modal-edit ref="updateAllPrice" title="Atualizar preço de todas especialidades" url="specialties/all" @submitForm="reloadTable">
      <template #form="{item}">
        <money-input v-model="item.price" :error="item.errors.price" class="lg:pr-6 w-full mt-4" label="Preço" />
      </template>
    </modal-edit>

    <modal-edit ref="modalEdit" title="Especialidades" url="specialties" @submitForm="reloadTable">
      <template #form="{item}">
        <text-input v-model="item.name" :error="item.errors.name" class="lg:pr-6 w-full" label="Nome" />
        <money-input v-model="item.price" :error="item.errors.price" class="lg:pr-6 w-full mt-4" label="Preço" />
      </template>
    </modal-edit>

    <modal ref="modalConfig" size="modal-lg" :modal-scrollable="true" :modal-backdrop="true">
      <template #header>
          <div class="text-gray-777 font-roboto uppercase">
              <span>Dados vitais - Ordenação</span>
          </div>
      </template>
      <template #body>
        <form action="">
          <div class="flex justify-center">
            <div class="w-full lg:w-1/2 m-2">
              <draggable class="list-group list-group-selected" itemKey="id" :list="this.formConfig.specialtiesOrdered">
                <template #item="{element}">
                    <div class="mb-4 list-group-item">
                      {{element.name}}
                      <input type="hidden" name="selected" :value="element.id">
                    </div>
                  </template>
              </draggable>
            </div>
          </div>
        </form>
      </template>
      <template #footer>
          <button type="button" class="px-6 py-2.5 bg-gray-600 text-white font-roboto font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out" @click.prevent="closeModalConfig">Cancelar</button>
          <loading-button :loading="loadModalConfig" class="btn-primary px-6 py-2.5 text-xs leading-tight uppercase ml-1" @click.prevent="saveModalConfig" type="submit">Salvar</loading-button>
      </template>
    </modal>
  </div>
</template>

<script>
import { Head, useForm } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout/Layout'
import LoadingButton from '@/Shared/Components/LoadingButton'
import ModalDelete from '@/Shared/Modal/ModalDelete'
import ModalEdit from '@/Shared/Modal/ModalEdit'
import TextInput from '@/Shared/Fields/TextInput'
import DataTable from '@/Shared/Components/DataTable'
import Modal from '@/Shared/Modal/Modal'
import draggable from 'vuedraggable'
import MoneyInput from '@/Shared/Fields/MoneyInput'

export default {
  components: {
    Head,
    LoadingButton,
    ModalDelete,
    ModalEdit,
    TextInput,
    DataTable,
    Modal,
    draggable,
    MoneyInput,
  },
  layout: Layout,

  props: [ 'defaultValueSpecialty' ],

  data() {
    return {
      loadModalConfig: false,
      specialtiesOrdered: null,
      loadTable: true,
      columns: [
        {
          uniqid: 'specialty_name',
          label: 'Especialidade',
          field: 'name',
          visible: true,
          sortable: false,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
        },
        {
          uniqid: 'specialty_total_professionals',
          label: 'Nº de profissionais',
          field: 'total_professionals',
          visible: true,
          sortable: false,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
        },
        {
          uniqid: 'specialty_price',
          label: 'Valor',
          field: 'price',
          visible: true,
          sortable: false,
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
        },
        {
          uniqid: 'actions',
          label: 'Ações',
          field: 'id',
          visible: true,
          align: 'center',
          classes: 'py-3 border-b',
          headerClass: 'p-4',
        },
      ],
    }
  },
  mounted() {
    this.loadOptions();
  },
  methods: {
    openModalConfirmDelete(item) {
      this.$refs.modalDelete.openModalDelete(item, `/specialties/${item.id}`, `Deseja realmente excluir a especialidade ${item.name}?`);
    },

    openSetPriceAll( item ) {
      this.$refs.updateAllPrice.openModalEdit({
        price: item.price ?? this.$props.defaultValueSpecialty,
      })
    },

    openModalEdit(item) {
      this.$refs.modalEdit.openModalEdit({
        id: item.id,
        name: item.name,
        price: item.price,
        errors: {}
      });
    },
    reloadTable() {
      this.loadTable = false;
      setTimeout(() => this.loadTable = true, 10);
    },
    openModalConfig() {
      this.formConfig = useForm({
        specialtiesOrdered: [].concat(this.specialtiesOrdered),
      });
      this.$refs.modalConfig.showModal = true;
    },
    closeModalConfig() {
      this.$refs.modalConfig.showModal = false;
    },
    saveModalConfig() {
      this.formConfig.post(`/specialties/update-config`, {
        onFinish: () => {
            if(!Object.keys(this.formConfig.errors).length) {
                this.closeModalConfig();
                this.loadOptions();
                this.reloadTable();
            } else {
                this.loadModalConfig = false;
            }
        }
      });
    },
    async loadOptions() {
      await fetch(
        `specialties/get-options`
      ).then(res => {
        res.json().then(json => {
          this.specialtiesOrdered = json.specialtiesOrdered;
        });
      });
    },
  },
}
</script>
<style>
  .list-group {
    @apply flex flex-col;
  }

  .list-group-item {
    @apply text-black
    relative block py-3 px-9 border cursor-move bg-gray-200
    hover:bg-gray-300;
  }
</style>